import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert,Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom'; 
import Logo from './../assets/icons/logo2.jpeg';
import { FaSignInAlt} from 'react-icons/fa';

const UserNav = () => {
  const navigate = useNavigate();
  const headerStyle = {
    backgroundColor: '#edf2fb',
    padding: '2px',
    display: 'flex',  // Use flexbox for layout
    alignItems: 'center',  // Align items vertically in the center
    justifyContent: 'space-between',  // Add space between items
    position: 'fixed',
    top: 0,
    width:'100%',
};

const navStyle = {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px'
    
};

const linkStyle = {
    color: 'black',
    textDecoration: 'none',
};


  return (
    <div>
    <header style={headerStyle}>
        <div style={{ display: 'flex', alignItems: 'center' ,padding :'7px 0px 0px 7px'}}>
        <a href="https://www.engagetalent.ai/#/" style={{textDecoration:'none',}} target='_blank'>
            <img src={Logo} alt="Logo" style={{ marginRight: '10px',height:'50px' }}/>
           <span style={{color:'blue',fontSize:'22px'}}>Engage</span><span style={{fontSize:'22px',color:'black'}}>Talent.AI</span>
            {/* Add more styling as needed for the logo */}</a>
        </div>
        {/* <nav style={navStyle}>
            <a href="#/login" style={linkStyle}> <FaSignInAlt style={{marginBottom:'4px'}} /> <span style={{fontWeight:600,fontSize:18}}>Login </span></a>
        
        </nav> */}
    </header>
</div>
       
     
  );
};

export default UserNav